import { BASE_URL } from '../API/BASE_URL';

export const getSingleParticipant = async (id) => {
  const response = await fetch(BASE_URL + `participants/participants/${id}/`, {
    method: 'GET',
  });

  const data = await response.json();

  return data;
};
